import { AppState } from "../appState";

// Base selector to access current Terminal state
export const currentTerminalSelector = (state: AppState) => state.activeTerminal;
